export default "__VITE_ASSET__765689f1__"